import { Col, Row } from "antd";
import React from "react";
import InstallByHtml from "../../home/component/installation/component/InstallByHtml";
import InstallByPackage from "../../home/component/installation/component/InstallByPackage";

export default function Usage() {
  return (
    <Row gutter={[0,40]}>
      <Col xs={24}>
        <h1>Usage</h1>
      </Col>
      <Col xs={24}>
        <Row gutter={[0,24]}>
          <Col xs={24}>
            <h4 style={{marginBottom: 16}} className="w-font-lg fw-600">Install by CDN (Plain HTML)</h4>
            <InstallByHtml />
          </Col>
          <Col  xs={24}>
            <h4 style={{marginBottom: 16}} className="w-font-lg fw-600">Install by Package</h4>
            <InstallByPackage />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
